module.exports = __webpack_public_path__ + "fc36c11d42f1f1a2e60de9931a54af2a.png";